import { store } from '@/config/store';

/**
 * AUP（まもリスCall）WebView のベースURL
 * 例: https://yamada-app-661635164260.asia-northeast1.run.app
 * PDF「まもリスCALL WebView 連携ガイド(2026-06-30)」準拠。
 */
const AUP_WEBVIEW_BASE_URL = import.meta.env.VITE_AUP_WEBVIEW_URL || '';

/**
 * まもリスCall のWebView画面
 * PDF「2. 提供エンドポイント（WebView URL）」記載のディープリンク。
 */
export const AUP_SCREEN_PATHS = {
  home: '/', // ホーム / レッカー依頼
  rescue: '/rescue', // レッカー依頼
  dispatch: '/dispatch', // 依頼状況
  notice: '/notice', // お知らせ
  setting: '/setting', // 各種設定
} as const;

export type AupScreen = keyof typeof AUP_SCREEN_PATHS;

/**
 * まもリスCall のWebViewを開くURLを生成する。
 *
 * ログイン済み会員のSanctumトークンを accessToken クエリに付与するだけで、
 * 会員はサインアップ不要でそのまま まもリスCall を利用できる（POST認証は行わない）。
 * トークン検証・会員情報取得・会員の自動作成はAUP側が WebView 内部の
 * GET /customer/auth/me（ヤマダ照合）で実施する。
 *
 * @param screen 開く画面（省略時はホーム）
 * @returns WebView URL。ベースURL未設定またはトークン未取得時は空文字。
 */
export const buildAupWebViewUrl = (screen: AupScreen = 'home'): string => {
  if (!AUP_WEBVIEW_BASE_URL) return '';

  const token = store.state.authInfo.token;
  if (!token) return '';

  const path = AUP_SCREEN_PATHS[screen] ?? AUP_SCREEN_PATHS.home;
  const base = AUP_WEBVIEW_BASE_URL.replace(/\/+$/, '');

  return `${base}${path}?accessToken=${encodeURIComponent(token)}`;
};
